import Vue from 'vue';
import Vuex from 'vuex';
import persistedState from 'vuex-persistedstate';
import users from './modules/users/index';
import partners from './modules/partners/index';
import criteriaCategories from './modules/criteria_categories/index';
import documents from './modules/documents/index';
import tasks from './modules/tasks/index';
import inspections from './modules/inspections/index';
import statements from './modules/statements/index';
import verificationQuestions from './modules/verification_questions/index';
import sites from './modules/sites/index';
import locations from './modules/locations/index';
import dashboards from './modules/dashboards/index';
import inspection_notes from './modules/inspection_notes/index';
import folders from './modules/folders/index';
import safetyDocuments from './modules/safety_documents/index';
import languages from './modules/languages/index';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

const store = new Vuex.Store({
  state: {
    loggedInUser: undefined,
    sessionTimeout: false,
    previousUser: undefined,
    selectedLanguage: 'hu_HU',
  },
  mutations: {
    storeLoggedInUser(state, user) {
      state.loggedInUser = user;
    },
    storeLanguage(state, lang) {
      state.selectedLanguage = lang;
      location.reload();
    },
    storePreviousUser(state, user) {
      state.loggedInUser = user;
    },
    removeLoggedInUser(state) {
      state.loggedInUser = null;
    },
    removePreviousUser(state) {
      state.previousUser = null;
    },
    setSessionTimout(state, value) {
      state.sessionTimeout = value;
    },
  },
  getters: {
    loggedInUser(state) {
      return state.loggedInUser;
    },
    previousUser(state) {
      return state.previousUser;
    },
    selectedLanguage(state) {
      return state.selectedLanguage;
    },
    sessionTimeout(state) {
      return state.sessionTimeout;
    },
  },
  modules: {
    users,
    partners,
    criteriaCategories,
    documents,
    tasks,
    inspections,
    statements,
    verificationQuestions,
    sites,
    locations,
    dashboards,
    inspection_notes,
    folders,
    safetyDocuments,
    languages,
  },
  strict: debug,
  plugins: [persistedState({
    paths: ['loggedInUser', 'previousUser', 'partners/commonData', 'selectedLanguage', 'sessionTimeout'],
  })],
});

export default store;



// WEBPACK FOOTER //
// ./src/store/store.js